module.exports = __webpack_public_path__ + "static/media/3.bb80d03e.jpg";